"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bodyScrollLock = require("body-scroll-lock");

var _scss = require("@scss");

var _Link = _interopRequireDefault(require("Link"));

var _Picture = _interopRequireDefault(require("Picture"));

var _Collapse = _interopRequireDefault(require("@components/Collapse"));

var _Navigation = _interopRequireDefault(require("@components/Layout/LegacyHeader/Navigation"));

var _Icon = _interopRequireDefault(require("@components/Icon"));

var _stylesModule = _interopRequireDefault(require("@components/Layout/Container/styles.module.scss"));

var _stylesModule2 = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getIndexSubItem(navs) {
  var defaultItem = {
    panel: -1,
    item: -1
  };
  var finalItem = null;

  if (navs) {
    var _finalItem;

    for (var i = 0; i < navs.length; i++) {
      var _navs$i;

      if ((_navs$i = navs[i]) !== null && _navs$i !== void 0 && _navs$i.items) {
        var _navs$i$items;

        var items = (_navs$i$items = navs[i].items) !== null && _navs$i$items !== void 0 ? _navs$i$items : [];
        finalItem = {
          panel: i,
          item: items.length > 0 ? items.findIndex(function (subItem) {
            var _subItem$items;

            return (subItem === null || subItem === void 0 ? void 0 : subItem.active) || (subItem === null || subItem === void 0 ? void 0 : (_subItem$items = subItem.items) === null || _subItem$items === void 0 ? void 0 : _subItem$items.some(function (subItemChild) {
              return subItemChild.active;
            }));
          }) : -1
        };
      }
    }

    return (_finalItem = finalItem) !== null && _finalItem !== void 0 ? _finalItem : defaultItem;
  }

  return defaultItem;
}

var LegacyHeader = /*#__PURE__*/(0, _react.forwardRef)(function Header(_ref, ref) {
  var sticky = _ref.sticky,
      _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === void 0 ? false : _ref$hideOnScroll,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      kindOnSticky = _ref.kindOnSticky,
      _ref$hamburger = _ref.hamburger,
      hamburger = _ref$hamburger === void 0 ? {
    "default": undefined,
    close: undefined
  } : _ref$hamburger,
      _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? {
    image: null,
    href: '/',
    title: '',
    className: ''
  } : _ref$logo,
      _ref$logoOnSticky = _ref.logoOnSticky,
      logoOnSticky = _ref$logoOnSticky === void 0 ? {
    image: null
  } : _ref$logoOnSticky,
      _ref$navs = _ref.navs,
      navs = _ref$navs === void 0 ? [] : _ref$navs,
      _ref$extraContent = _ref.extraContent,
      extraContent = _ref$extraContent === void 0 ? '' : _ref$extraContent,
      _ref$preContent = _ref.preContent,
      preContent = _ref$preContent === void 0 ? '' : _ref$preContent,
      _ref$postContent = _ref.postContent,
      postContent = _ref$postContent === void 0 ? '' : _ref$postContent,
      _ref$footerMobile = _ref.footerMobile,
      footerMobile = _ref$footerMobile === void 0 ? null : _ref$footerMobile,
      classes = _ref.classes,
      htmlProps = _ref.htmlProps,
      _ref$isMenuDesktop = _ref.isMenuDesktop,
      isMenuDesktop = _ref$isMenuDesktop === void 0 ? false : _ref$isMenuDesktop,
      events = _ref.events;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollUp = _useState4[0],
      setScrollUp = _useState4[1];

  var _useState5 = (0, _react.useState)(function () {
    return getIndexSubItem(navs);
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      openPanel = _useState6[0],
      setActivePanel = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isStucked = _useState8[0],
      setStucked = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      direction = _useState10[0],
      setDirection = _useState10[1];

  var _ref2 = events !== null && events !== void 0 ? events : {},
      onClickLink = _ref2.onClickLink;

  var headerRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      close: function close() {
        return setMenuOpen(false);
      },
      open: function open() {
        return setMenuOpen(true);
      },
      toggle: function toggle() {
        return setMenuOpen(function (prevValue) {
          return !prevValue;
        });
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined') {
      return;
    }

    var lastScroll = 0;

    var onScroll = function onScroll() {
      setScrollUp(window.scrollY > 10 && window.scrollY > lastScroll);
      setStucked(window.scrollY > 10);
      setDirection(window.scrollY > lastScroll ? 'down' : 'up');
      lastScroll = window.scrollY;
    };

    var forceStatus = function forceStatus(e) {
      var _e$detail;

      if (e !== null && e !== void 0 && (_e$detail = e.detail) !== null && _e$detail !== void 0 && _e$detail.opened) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('menu', forceStatus);
    return function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('menu', forceStatus);
    };
  }, []);
  var menuOnMouseEnter = (0, _react.useCallback)(function (e) {
    if (!isMenuDesktop && e._reactName === 'onMouseEnter') {
      return;
    }

    if (e.target === e.currentTarget) {
      // only when click <li> item
      if (parseInt(e.currentTarget.dataset['panel']) !== openPanel.panel || parseInt(e.currentTarget.dataset['item']) !== openPanel.item) {
        e.preventDefault();
        setActivePanel({
          panel: parseInt(e.currentTarget.dataset['panel']),
          item: parseInt(e.currentTarget.dataset['item'])
        });
        return;
      }

      setActivePanel({
        panel: -1,
        item: -1
      });
    }
  }, [isMenuDesktop, openPanel.item, openPanel.panel]);
  var menuOnMouseOut = (0, _react.useCallback)(function (e) {
    if (!isMenuDesktop) {
      return;
    }

    setActivePanel({
      panel: -1,
      item: -1
    });
  }, [isMenuDesktop]);

  var onMenuClick = function onMenuClick(e, href) {
    if (typeof onClickLink === 'function') {
      onClickLink(e, href);
    }

    if (!isMenuDesktop) {
      return;
    }

    setMenuOpen(false);
  };

  (0, _react.useEffect)(function () {
    if (!headerRef.current || typeof window === 'undefined') {
      return;
    }

    if (menuOpen) {
      window.document.body.dataset.menuOpen = 'true';
      (0, _bodyScrollLock.disableBodyScroll)(headerRef.current);
    } else {
      window.document.body.dataset.menuOpen = 'false';
      (0, _bodyScrollLock.enableBodyScroll)(headerRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [menuOpen, headerRef.current]);
  var stickyClasses = [sticky && _stylesModule2["default"]['sticky'], sticky === 'bottom' && _stylesModule2["default"]["sticky-bottom"], sticky && hideOnScroll && scrollUp && _stylesModule2["default"]['sticky-hide'], sticky && logoOnSticky && isStucked ? _stylesModule2["default"]['alternative-mode'] : _stylesModule2["default"]['default-mode'], hideOnScroll && _stylesModule2["default"]['hide-on-scroll']];
  var onScrollClasses = [direction === 'up' && (classes === null || classes === void 0 ? void 0 : classes.scrollUp), direction === 'down' && (classes === null || classes === void 0 ? void 0 : classes.scrollDown)];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("header", _extends({
    ref: headerRef,
    className: (0, _scss.cls)([classes === null || classes === void 0 ? void 0 : classes.wrapper, _stylesModule2["default"]['kind--default'], _stylesModule2["default"]['navbar'], kind !== 'default' && _stylesModule2["default"]["kind--".concat(kind)], isStucked && !menuOpen && _stylesModule2["default"]["kind--".concat(kindOnSticky)], _stylesModule2["default"]['navbar'], isMenuDesktop ? _stylesModule2["default"]['menu-desktop'] : _stylesModule2["default"]['menu-burger'], menuOpen && _stylesModule2["default"]['header-burger-opened']].concat(stickyClasses, onScrollClasses)),
    "data-header-opened": menuOpen ? true : false
  }, htmlProps ? htmlProps : {}), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-wrapper'], !fullWidth && _stylesModule["default"]['container'])
  }, (logo === null || logo === void 0 ? void 0 : logo.image) && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-logo'])
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-logo-aux'], logo.className),
    href: logo === null || logo === void 0 ? void 0 : logo.href
  }, (logoOnSticky === null || logoOnSticky === void 0 ? void 0 : logoOnSticky.image) && /*#__PURE__*/_react["default"].createElement(_Picture["default"], {
    classes: {
      wrapper: (0, _scss.cls)(_stylesModule2["default"]['logo-alternative'])
    },
    image: logoOnSticky.image,
    alt: logo.title
  }), /*#__PURE__*/_react["default"].createElement(_Picture["default"], {
    classes: {
      wrapper: (0, _scss.cls)(_stylesModule2["default"]['logo-default'])
    },
    image: logo.image,
    alt: logo.title
  }))), preContent && preContent, (navs === null || navs === void 0 ? void 0 : navs.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": "Menu",
    "aria-hidden": true,
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-burger'], menuOpen && _stylesModule2["default"]['navbar-burger-opened']),
    onClick: function onClick(event) {
      setMenuOpen(!menuOpen);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: (0, _scss.cls)(_stylesModule2["default"]['icon-default']),
    name: hamburger && hamburger["default"] ? hamburger["default"] : 'hamburger-default',
    alt: "Open menu"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: (0, _scss.cls)(_stylesModule2["default"]['icon-close']),
    name: hamburger.close ? hamburger.close : 'hamburger-close',
    alt: "Close menu"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-collapse'], classes === null || classes === void 0 ? void 0 : classes.collapse)
  }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    isOpened: menuOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule2["default"]['navbar-content'])
  }, navs ? navs.map(function (nav, i) {
    return /*#__PURE__*/_react["default"].createElement(_Navigation["default"], {
      items: nav,
      panelIndex: i,
      key: i,
      menuOnMouseEnter: menuOnMouseEnter,
      menuOnMouseOut: menuOnMouseOut,
      menuOnClick: onMenuClick,
      openPanel: openPanel,
      classes: {
        menuListItem: classes === null || classes === void 0 ? void 0 : classes.menuListItem,
        menuItem: classes === null || classes === void 0 ? void 0 : classes.menuItem,
        submenuItem: classes === null || classes === void 0 ? void 0 : classes.submenuItem
      }
    });
  }) : null, footerMobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule2["default"]['footer-mobile'])
  }, footerMobile))))) : null, postContent && postContent)), extraContent && /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: extraContent
    }
  }));
});
var _default = LegacyHeader;
exports["default"] = _default;